import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import Moment from "moment";
import { isEmpty } from "lodash";
import Datetime from "react-datetime";
import {
  Tab,
  Col,
  Nav,
  NavItem,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { Dropdown } from "components/Dropdown/Dropdown";
import { CheckBoxSingle } from "../../components/checkboxes/check-box-single";
import WorkOrderHistory from "./WorkOrderHistory";
import * as RFSActionType from "Request-Services/constants";
import * as AuthActionType from "../../Auth/constants";
import * as ProjectActionType from "Projects/constants";
import * as PunchListActionType from "Punch-List/constants";
import * as RequestTypes from "Request-Types/constants";
import * as WorkOrderAction from "../constants";
import { AppSettings } from "../../constants";
import Translate from "components/translate";
import EditContactInformationPopup from "./EditContactInformationPopup";

var yesterday = Moment().subtract(1, "day");
var isValidAppointmentDate = function (current) {
  return current.isAfter(yesterday);
};
class RFSInfo extends React.Component {
  static propTypes = {
    RFSInformation: PropTypes.object,
    displayStatus: PropTypes.bool,
    displayTab: PropTypes.bool,
    displayNote: PropTypes.bool,
    dispatch: PropTypes.func,
    history: PropTypes.object,
    location: PropTypes.object,
    ManagerStore: PropTypes.object,
    onToggleReviewRFS: PropTypes.func,
    userList: PropTypes.array,
    adminSelectList: PropTypes.array,
    requestTypeList: PropTypes.array,
    mode: PropTypes.string,
    LotProfile: PropTypes.object,
    ContactInformationList: PropTypes.array,
    hideHistory: PropTypes.bool, // help hiding history tab on public page viewed by subcontractor
  };

  constructor(props) {
    super(props);
    this.state = {
      isEditRFS: [],
      isEditRFSRequestType: [],
      isEditReviewDate: [],
      user: null,
      requestTypeChange: null,
      reviewDateChange: null,
      contactInformationChange: null,
      check: false,
      toggleEditContactInfoPopup: false,
      requestTypeList: props.requestTypeList,
      dateError: "",
    };
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: RFSActionType.RESET_RFS_INFO,
    });
  }

  bindingWorkOrderHistory = () => {
    this.props.dispatch({
      type: RFSActionType.GET_RFS_HISTORY_ASYNC,
      params: {
        refNo: this.props.RFSInformation.refNo,
      },
    });
  };

  onSelectTab = (selectedKey) => {
    const queryParams = new URLSearchParams(this.props.location.search);
    this.props.history.push({
      pathname: this.props.location.pathname,
      search: queryParams.get("mode")
        ? `?mode=${queryParams.get("mode")}&active=${selectedKey}`
        : `?active=${selectedKey}`,
    });
  };

  toolTip() {
    return (
      <Tooltip className="in tooltip-siteone" placement="left" id="tooltip">
        <span>Need review</span>
      </Tooltip>
    );
  }

  onToggleEditRFS = (field) => {
    this.setState({
      isEditRFS: { [field]: !this.state.isEditRFS[field] },
      errorMessage: null,
      user: {
        text: this.props.RFSInformation.managedByUser.displayName,
        value: this.props.RFSInformation.managedByUser.id,
        extensionValue: {
          email: this.props.RFSInformation.managedByUser.email,
        },
      },
      check: false,
    });
  };

  onToggleEditRFSReviewdate = (field) => {
    const { RFSInformation } = this.props;

    this.setState(
      {
        isEditReviewDate: { [field]: !this.state.isEditReviewDate[field] },
        errorMessage: null,
        reviewDateChange:
          this.props.RFSInformation.reviewDate == "0001-01-01T00:00:00Z"
            ? new Date()
            : this.props.RFSInformation.reviewDate,
        check: false,
      },
      () => {
        this.props.dispatch({
          type: RFSActionType.GET_BY_RFS_ID_ASYNC,
          params: RFSInformation.refNo,
        });
      }
    );
  };

  onToggleEditRFSRequestType = (field) => {
    const { RFSInformation } = this.props;

    this.setState(
      {
        isEditRFSRequestType: {
          [field]: !this.state.isEditRFSRequestType[field],
        },
        errorMessage: null,
        requestTypeChange: {
          text: this.props.RFSInformation.requestType.name,
          value: this.props.RFSInformation.requestType.id,
          // extensionValue: {
          //   email: this.props.RFSInformation.requestType.email
          // }
        },
        check: false,
      },
      () => {
        this.props.dispatch({
          type: RFSActionType.GET_BY_RFS_ID_ASYNC,
          params: RFSInformation.refNo,
        });
      }
    );
  };

  updateRFS = (params) => {
    const { RFSInformation, mode } = this.props;

    if (RFSInformation.managedByUser.id !== params.managedByUserId) {
      const actionType =
        mode === "rfs"
          ? RFSActionType.UPDATE_RFS_MANAGE_BY_ASYNC
          : PunchListActionType.UPDATE_PUNCH_LIST_MANAGED_BY_ASYNC;

      this.props.dispatch({
        type: actionType,
        params: {
          data: {
            ...params,
          },
          refNo: RFSInformation.refNo,
        },
        callback: () => this.onToggleEditRFS("manageBy"),
      });
    } else {
      this.onToggleEditRFS("manageBy");
    }
  };

  updateRequestType = (params) => {
    const { RFSInformation } = this.props;

    if (RFSInformation.requestType.id !== params.requestTypeId) {
      // const actionType = mode === 'rfs'
      //   ? RFSActionType.UPDATE_RFS_REQUEST_TYPE_ASYNC
      //   : PunchListActionType.UPDATE_PUNCH_LIST_MANAGED_BY_ASYNC;

      this.props.dispatch({
        type: RFSActionType.UPDATE_RFS_REQUEST_TYPE_ASYNC,
        params: {
          data: {
            ...params,
          },
          refNo: RFSInformation.refNo,
        },
        callback: () => this.onToggleEditRFSRequestType("requestType"),
      });
    } else {
      this.onToggleEditRFSRequestType("requestType");
    }
  };
  updateReviewDate = (params) => {
    const { RFSInformation } = this.props;
    this.props.dispatch({
      type: RFSActionType.GET_RFS_REVIEW_DATE,
      params: {
        rfsId: RFSInformation.refNo,
        data: {
          ReviewDate: params,
        },
      },
      callback: () => this.onToggleEditRFSReviewdate("reviewDate"),
    });
  };
  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value,
    });
  };

  onChecked = () => {
    this.setState({
      check: !this.state.check,
      user: null,
    });
  };

  fetchUser = () => {
    this.setState({
      isFetchingUser: true,
    });
    if (this.state.check) {
      this.props.dispatch({
        type: AuthActionType.SELECT_LIST_ADMIN_SUPER_ADMIN_ASYNC,
        params: {
          searchKey: "",
          selectedValue: "",
        },
        callback: () => {
          this.setState({
            isFetchingUser: false,
          });
        },
      });
    } else {
      this.props.dispatch({
        type: ProjectActionType.GET_LIST_USER_ASYNC,
        params: {
          projectId: this.props.RFSInformation.project.id,
        },
        callback: () => {
          this.setState({
            isFetchingUser: false,
          });
        },
      });
    }
  };

  fetchRequestType = () => {
    this.setState({
      isFetchingRequestType: true,
    });
    this.props.dispatch({
      type: RequestTypes.SELECT_LIST_ITEM_ASYNC,
      params: {
        searchKey: "",
        selectedValue: "",
        isBlueTape: false,
      },
      callback: () => {
        this.setState({
          isFetchingRequestType: false,
        });
      },
    });
  };

  onTogglePopupEditContactInfo = () => {
    this.setState({
      toggleEditContactInfoPopup: !this.state.toggleEditContactInfoPopup,
      contactInformationChange: {
        text: this.props.RFSInformation.contactInformation.displayName,
        value: this.props.RFSInformation.contactInformation.id,
      },
    });
  };

  onCloseEditContactInfoPopup = (callback) => {
    this.setState(
      {
        toggleEditContactInfoPopup: false,
      },
      callback
    );
  };

  onFetchContactInformation = (callback) => {
    this.props.dispatch({
      type: WorkOrderAction.GET_CONTACT_INFO_ASYNC,
      params: {
        refNo: this.props.RFSInformation.refNo,
      },
      callback,
    });
  };

  onEditContactInformation = (params, callback) => {
    this.props.dispatch({
      type: WorkOrderAction.EDIT_CONTACT_INFO_ASYNC,
      params: {
        refNo: this.props.RFSInformation.refNo,
        param: {
          PrioritizedContactId: params.PrioritizedContactId,
        },
      },
      callback,
    });
  };
  onGetNewContactInformation = () => {
    const { RFSInformation } = this.props;
    this.props.dispatch({
      type: RFSActionType.GET_BY_RFS_ID_ASYNC,
      params: RFSInformation.refNo,
    });
  };

  renderWarningIcon = (RFSInformation) => {
    if (
      RFSInformation.status === 0 &&
      AppSettings.clientTypeValue === "Builder"
    ) {
      return (
        <OverlayTrigger
          placement="top"
          overlay={this.toolTip()}
          delayHide={10}
          delayShow={500}
        >
          <i
            className="fa fa-warning"
            style={{ fontSize: "15px", color: "#ffc801" }}
          />
        </OverlayTrigger>
      );
    }
    return null;
  };

  renderRFSStatus = (status) => {
    return (
      <strong>
        {AppSettings.RFS_STATUS_VALUE.find((x) => x.key === status).value}
      </strong>
    );
  };
  onChangeReviewDate = (reviewDate) => {
    if (typeof reviewDate === "string") {
      this.setState({ reviewDate });
      if (
        Moment(reviewDate, "MM/DD/YYYY", true).isValid() ||
        reviewDate === ""
      ) {
        this.setState({ dateError: null });
      } else {
        this.setState({ dateError: "Invalid datetime." });
      }
    } else {
      this.setState({
        reviewDateChange: Moment(reviewDate).format("MM/DD/YYYY"),
      });
      if (
        Moment(reviewDate, "MM/DD/YYYY", true).isValid() ||
        reviewDate === ""
      ) {
        this.setState({ dateError: null });
      } else {
        this.setState({ dateError: "Invalid datetime." });
      }
    }
  };
  renderGeneralInformation = () => {
    const { RFSInformation, mode } = this.props;
    const {
      isEditRFS,
      isEditRFSRequestType,
      user,
      requestTypeChange,
      isEditReviewDate,
      reviewDateChange,
    } = this.state;

    let contactInfo = RFSInformation.managedByUser;
    if (RFSInformation.contactInformation) {
      contactInfo = RFSInformation.contactInformation;
    } else {
      if (RFSInformation.managedByHomeOwner) {
        contactInfo = RFSInformation.managedByHomeOwner;
      }
      if (RFSInformation.isTenancyContact && RFSInformation.managedByTenancy) {
        contactInfo = RFSInformation.managedByTenancy;
      }
    }

    let userOptions = [
      {
        text: this.props.RFSInformation.managedByUser.displayName,
        value: this.props.RFSInformation.managedByUser.id,
        extensionValue: {
          email: this.props.RFSInformation.managedByUser.email,
        },
      },
    ];
    if (this.state.check) {
      if (!isEmpty(this.props.adminSelectList)) {
        userOptions = this.props.adminSelectList;
      }
    } else {
      if (!isEmpty(this.props.userList)) {
        userOptions = this.props.userList;
      }
    }

    return (
      <div>
        {/* left-column */}
        <div className="col-sm-6">
          {this.props.displayStatus && (
            <div className="row">
              <div className="form-group">
                <label className="rfs-info-label control-label">Status</label>
                <div className="rfs-info-value control-label name form-text-label">
                  <strong>
                    {this.renderRFSStatus(this.props.RFSInformation.status)}
                  </strong>
                  {RFSInformation.status === 0 &&
                    AppSettings.clientTypeValue === "Builder" && (
                      <p className="rfs-warning-review">
                        Builder rep needs to{" "}
                        <a onClick={this.props.onToggleReviewRFS} href="#">
                          review
                        </a>{" "}
                        'RFS managed by' and 'Request type'
                      </p>
                    )}
                </div>
              </div>
            </div>
          )}

          <div className="row">
            <div className="form-group">
              <label className="rfs-info-label control-label">
                <Translate translateKey="project" capitalize />
              </label>
              <div className="rfs-info-value control-label name form-text-label">
                <strong>{this.props.RFSInformation.project.name}</strong>
                {!this.props.displayStatus &&
                  RFSInformation.status === 0 &&
                  AppSettings.clientTypeValue === "Builder" && (
                    <p className="rfs-warning-review">
                      Builder rep needs to{" "}
                      <a onClick={this.props.onToggleReviewRFS} href="#">
                        review
                      </a>{" "}
                      'RFS managed by' and 'Request type'
                    </p>
                  )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="form-group">
              <label className="rfs-info-label control-label">
                <Translate translateKey="lot" capitalize /># - Address
              </label>
              <div className="rfs-info-value control-label name form-text-label">
                <strong>
                  {this.props.RFSInformation.lot.name} -{" "}
                  {this.props.RFSInformation.lot.streetAddress}
                </strong>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="form-group">
              <label className="rfs-info-label control-label">
                Creation Date
              </label>
              <div className="rfs-info-value control-label name form-text-label">
                <strong>
                  {this.props.RFSInformation.createdDate ? (
                    Moment(this.props.RFSInformation.createdDate).format(
                      "MM/DD/YYYY"
                    )
                  ) : (
                    <span style={{ opacity: 0.5 }}>(Not specified)</span>
                  )}
                </strong>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="form-group">
              <label className="rfs-info-label control-label">
                Orginal COE
              </label>
              <div className="rfs-info-value control-label name form-text-label">
                <strong>
                  {this.props.RFSInformation.lot.coe ? (
                    Moment(this.props.RFSInformation.lot.coe).format(
                      "MM/DD/YYYY"
                    )
                  ) : (
                    <span style={{ opacity: 0.5 }}>(Not specified)</span>
                  )}
                </strong>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="form-group">
              {isEditRFS.manageBy ? (
                <div
                  className="col-sm-10"
                  style={{ marginTop: 5, paddingLeft: 5 }}
                >
                  RFS managed by <span className="text-danger"> *</span>
                  <i
                    className="fa fa-check subcontractor-edit-trade-btn pull-right"
                    onClick={() =>
                      this.updateRFS({ managedByUserId: this.state.user.value })
                    }
                  />
                  <i
                    className="fa fa-close subcontractor-edit-trade-btn pull-right"
                    onClick={() => this.onToggleEditRFS("manageBy")}
                  />
                </div>
              ) : (
                <label className="rfs-info-label control-label">
                  RFS managed by
                </label>
              )}

              {isEditRFS.manageBy ? (
                <div
                  className="col-sm-10 control-label name form-text-label"
                  style={{ paddingLeft: 5 }}
                >
                  <Dropdown
                    filter={true}
                    onChange={(ref) => {
                      this.onSelectChange(ref, "user");
                    }}
                    className="filestring-dropdown filter-dropdown"
                    placeholder="Please select"
                    onRemote={this.fetchUser}
                    options={userOptions}
                    loading={this.state.isFetchingUser}
                    value={user}
                    optionLabel="text"
                    style={{ width: "100%", marginBottom: 0 }}
                  />
                  <CheckBoxSingle
                    style={{ marginTop: 0, marginBottom: 10 }}
                    checked={this.state.check}
                    ref={(c) => {
                      this.check = c;
                    }}
                    name="checkAdmin"
                    label="I want to assign this request to admin"
                    className="checkbox-default noteTitle"
                    onChecked={this.onChecked}
                  />
                </div>
              ) : (
                <div className="rfs-info-value control-label name form-text-label">
                  <strong>
                    {this.props.RFSInformation.managedByUser.displayName}
                  </strong>{" "}
                  {this.renderWarningIcon(RFSInformation)}
                  {this.props.RFSInformation.status !== 3 &&
                    RFSInformation.statusValue === "Open" &&
                    AppSettings.clientTypeValue === "Builder" && (
                      <i
                        className="fa fa-pencil subcontractor-edit-trade-btn"
                        onClick={() => this.onToggleEditRFS("manageBy")}
                      />
                    )}
                </div>
              )}
            </div>
          </div>

          {mode === "rfs" && RFSInformation.statusValue === "Open" && (
            <div className="row">
              <div className="form-group">
                {isEditRFSRequestType.requestType ? (
                  <div
                    className="col-sm-10"
                    style={{ marginTop: 5, paddingLeft: 5 }}
                  >
                    Request type <span className="text-danger"> *</span>
                    <i
                      className="fa fa-check subcontractor-edit-trade-btn pull-right"
                      onClick={() =>
                        this.updateRequestType({
                          requestTypeId: this.state.requestTypeChange.value,
                        })
                      }
                    />
                    <i
                      className="fa fa-close subcontractor-edit-trade-btn pull-right"
                      onClick={() =>
                        this.onToggleEditRFSRequestType("requestType")
                      }
                    />
                  </div>
                ) : (
                  <label className="rfs-info-label control-label">
                    Request type
                  </label>
                )}

                {isEditRFSRequestType.requestType ? (
                  <div
                    className="col-sm-10 control-label name form-text-label"
                    style={{ paddingLeft: 5 }}
                  >
                    <Dropdown
                      filter={true}
                      onChange={(ref) => {
                        this.onSelectChange(ref, "requestTypeChange");
                      }}
                      className="filestring-dropdown filter-dropdown"
                      placeholder="Please select"
                      options={this.props.requestTypeList}
                      loading={this.state.isFetchingRequestType}
                      style={{ width: "100%" }}
                      optionLabel="text"
                      onRemote={this.fetchRequestType}
                      value={requestTypeChange}
                    />
                  </div>
                ) : (
                  <div className="rfs-info-value control-label name form-text-label">
                    <strong>
                      {this.props.RFSInformation.requestType.name}
                    </strong>{" "}
                    {this.renderWarningIcon(RFSInformation)}
                    {this.props.RFSInformation.status !== 3 &&
                      RFSInformation.statusValue === "Open" &&
                      AppSettings.clientTypeValue === "Builder" && (
                        <i
                          className="fa fa-pencil subcontractor-edit-trade-btn"
                          onClick={() =>
                            this.onToggleEditRFSRequestType("requestType")
                          }
                        />
                      )}
                  </div>
                )}
              </div>
            </div>
          )}

          {mode === "punchList" ||
            (RFSInformation.statusValue === "New" && (
              <div className="row">
                <div className="form-group">
                  <label className="rfs-info-label control-label">
                    Request type
                  </label>
                  <div className="rfs-info-value control-label name form-text-label">
                    <strong>
                      {this.props.RFSInformation.requestType.name}
                    </strong>{" "}
                    {this.renderWarningIcon(RFSInformation)}
                  </div>
                </div>
              </div>
            ))}

          {this.props.displayNote &&
            !isEmpty(this.props.LotProfile && this.props.LotProfile.note) && (
              <div className="row">
                <div className="form-group">
                  <label className="rfs-info-label control-label">Note</label>
                  <div className="rfs-info-value control-label name form-text-label">
                    <strong>
                      {this.props.LotProfile && this.props.LotProfile.note}
                    </strong>
                  </div>
                </div>
              </div>
            )}
          {RFSInformation.status === 4 && (
            <div className="row">
              <div className="form-group">
                <label className="rfs-info-label control-label">
                  Schedule dated
                </label>
                <div className="rfs-info-value control-label name form-text-label">
                  <strong>
                    {this.props.RFSInformation.scheduleDate &&
                      Moment(this.props.RFSInformation.scheduleDate).format(
                        "MM/DD/YYYY"
                      )}
                  </strong>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* right-column */}
        <div className="col-sm-6">
          <div className="row">
            <div className="form-group">
              <label
                className="col-sm-12 control-label"
                style={{ fontSize: "14px", color: "#9B9B9B" }}
              >
                Contact information{" "}
                {mode === "rfs" &&
                  this.props.RFSInformation.status !== 3 &&
                  RFSInformation.statusValue === "Open" && (
                    <i
                      style={{ fontSize: 14 }}
                      className="fa fa-pencil subcontractor-edit-trade-btn"
                      onClick={this.onTogglePopupEditContactInfo}
                    />
                  )}
              </label>
            </div>
            {this.state.toggleEditContactInfoPopup && (
              <EditContactInformationPopup
                onFetchContactInformation={this.onFetchContactInformation}
                contactInformationChange={this.state.contactInformationChange}
                onGetNewContactInformation={this.onGetNewContactInformation}
                onEditContactInformation={this.onEditContactInformation}
                ContactInformationList={this.props.ContactInformationList}
                onClose={this.onCloseEditContactInfoPopup}
              />
            )}
          </div>

          <div className="row">
            <div className="form-group">
              <label className="rfs-info-label control-label">Name</label>
              <div className="rfs-info-value control-label name form-text-label">
                <strong>{contactInfo.displayName}</strong>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="form-group">
              <label className="rfs-info-label control-label">Phone</label>
              <div className="rfs-info-value control-label name form-text-label">
                <strong>
                  {contactInfo.phoneNumber || (
                    <span style={{ opacity: 0.5 }}>(Not specified)</span>
                  )}
                </strong>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="form-group">
              <label className="rfs-info-label control-label">
                Daytime phone
              </label>
              <div className="rfs-info-value control-label name form-text-label">
                {contactInfo.dayTimePhoneNumber ? (
                  <strong>{contactInfo.dayTimePhoneNumber}</strong>
                ) : (
                  <strong>
                    <span style={{ opacity: 0.5 }}>(Not specified)</span>
                  </strong>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="form-group">
              <label className="rfs-info-label control-label">Email</label>
              <div className="rfs-info-value control-label name form-text-label">
                <strong>{contactInfo.email}</strong>
              </div>
            </div>
          </div>

          {/* RFS Review Date */}
          {mode === "rfs" && RFSInformation.statusValue === "Open" && (
            <div className="row">
              <div className="form-group">
                {isEditReviewDate.reviewDate ? (
                  <div
                    className="col-sm-10"
                    style={{ marginTop: 5, paddingLeft: 5 }}
                  >
                    Review Date <span className="text-danger"></span>
                    <i
                      className="fa fa-check subcontractor-edit-trade-btn pull-right"
                      onClick={() => this.updateReviewDate(reviewDateChange)}
                    />
                    <i
                      className="fa fa-close subcontractor-edit-trade-btn pull-right"
                      onClick={() =>
                        this.onToggleEditRFSReviewdate("requestType")
                      }
                    />
                  </div>
                ) : (
                  <label className="rfs-info-label control-label">
                    Review Date
                  </label>
                )}

                {isEditReviewDate.reviewDate ? (
                  <div
                    className="col-sm-10 control-label name form-text-label"
                    style={{ paddingLeft: 5 }}
                  >
                    <Datetime
                      ref={(ref) => {
                        this.coe = ref;
                      }}
                      inputProps={{ placeholder: "mm/dd/yyyy" }}
                      timeFormat={false}
                      value={Moment(
                        reviewDateChange == "0001-01-01T00:00:00Z"
                          ? new Date()
                          : reviewDateChange
                      ).format("MM/DD/YYYY")}
                      onChange={(date) => this.onChangeReviewDate(date)}
                      closeOnSelect={true}
                      isValidDate={isValidAppointmentDate}
                    />
                    {this.state.dateError && (
                      <span
                        className="text-danger"
                        style={{ fontSize: 12, marginTop: 5 }}
                      >
                        {this.state.dateError}
                      </span>
                    )}
                  </div>
                ) : (
                  <div className="rfs-info-value control-label name form-text-label">
                    {this.props.RFSInformation.reviewDate ==
                    "0001-01-01T00:00:00Z" ? (
                      <span style={{ opacity: 0.5 }}>(Not specified)</span>
                    ) : (
                      <strong>
                        {Moment(this.props.RFSInformation.reviewDate).format(
                          "MM/DD/YYYY"
                        )}
                      </strong>
                    )}
                    {this.renderWarningIcon(RFSInformation)}
                    {this.props.RFSInformation.status !== 3 &&
                      RFSInformation.statusValue === "Open" &&
                      AppSettings.clientTypeValue === "Builder" && (
                        <i
                          className="fa fa-pencil subcontractor-edit-trade-btn"
                          onClick={() =>
                            this.onToggleEditRFSReviewdate("reviewDate")
                          }
                        />
                      )}
                  </div>
                )}
              </div>
            </div>
          )}

          {mode === "rfs" && RFSInformation.statusValue === "Closed" && (
            <div className="row">
              <div className="form-group">
                <label className="rfs-info-label control-label">
                  Review Date
                </label>
                <div className="rfs-info-value control-label name form-text-label">
                  {this.props.RFSInformation.reviewDate ==
                  "0001-01-01T00:00:00Z" ? (
                    <span style={{ opacity: 0.5 }}>(Not specified)</span>
                  ) : (
                    <strong>
                      {Moment(this.props.RFSInformation.reviewDate).format(
                        "MM/DD/YYYY"
                      )}
                    </strong>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  render() {
    const queryParams = new URLSearchParams(this.props.location.search);
    const active = queryParams.get("active")
      ? queryParams.get("active")
      : "general-info";
    if (this.props.RFSInformation) {
      return (
        <div
          className="rfs-wrapper col-sm-12 box-form-siteone"
          style={!this.props.displayTab ? { padding: 20 } : {}}
        >
          {this.props.displayTab ? (
            <Tab.Container id="rfs-info-tab" defaultActiveKey={active}>
              <div>
                <Col sm={12} style={{ padding: 0 }}>
                  <Nav
                    className="wo-tab"
                    bsStyle="tabs"
                    onSelect={this.onSelectTab}
                    style={{ borderBottom: "none" }}
                  >
                    <NavItem eventKey="general-info">
                      General information
                    </NavItem>
                    {!this.props.hideHistory && (
                      <NavItem eventKey="history">History</NavItem>
                    )}
                  </Nav>
                </Col>
                <Col sm={12} style={{ padding: 15, marginTop: -30 }}>
                  <Tab.Content
                    animation
                    className="clearfix rfs-general-info-tab"
                  >
                    <Tab.Pane eventKey="general-info">
                      {this.renderGeneralInformation()}
                    </Tab.Pane>
                    {active === "history" && (
                      <Tab.Pane eventKey="history">
                        <WorkOrderHistory
                          bindingWorkOrderHistory={this.bindingWorkOrderHistory}
                          WorkOrderHistories={
                            this.props.ManagerStore.RFSHistory
                          }
                          wrapperHeight={154}
                        />
                      </Tab.Pane>
                    )}
                  </Tab.Content>
                </Col>
              </div>
            </Tab.Container>
          ) : (
            this.renderGeneralInformation()
          )}
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    ManagerStore: state.RFSStore,
    userList: state.ProjectStore.UserSelectList,
    adminSelectList: state.authReducer.adminSelectList,
    requestTypeList: state.RequestTypeStore.ItemList,
    ContactInformationList: state.WorkOrderReducer.ContactInformationList,
  };
};

export default connect(mapStateToProps)(RFSInfo);



// WEBPACK FOOTER //
// ./src/Work-Orders/Components/RFSInfo.js